<template>
  <div class="container p-0">
    <div class="row lh-base">
      <div 
        class="col-9"
        :class="{ 'main': main }"
      >
        {{ text }}
      </div>
      <div class="col text-end">
        <Price
          :amount="price"
          :prefix="prefix"
          :dash="!prefix"
          :class="{ 'fw-bold': !!main }"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Price from '../../common/Price.vue';

export default defineComponent({
  components: { Price },

  props: {
    text: { type: String, default: '' },
    price: { type: Number, default: 0 },
    prefix: { type: Boolean, default: false },
    main: { type: Boolean, default: false },
  },
})
</script>

<style lang="scss" scoped>
  .main {
    font-weight: bold;
    white-space: pre-wrap;
  }
</style>
